export default __webpack_public_path__ + "static/media/Emile.afcea66b.jpg";